module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upAvatar"
  }, [(_vm.mobileState.iPhone) ? _c('input', {
    ref: "inputImg",
    staticClass: "inputImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }) : (_vm.mobileState.Android) ? _c('input', {
    ref: "inputImg",
    staticClass: "inputImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }) : _c('input', {
    ref: "inputImg",
    staticClass: "inputImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.fileFn1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "img"
  }, [(_vm.imgUrls && _vm.imgUrls.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.imgUrlFn
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../../assets/img/yonghu/logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "replaceBut",
    on: {
      "click": _vm.AddFn
    }
  }, [_vm._v("\n      上传头像\n    ")])]), _vm._v(" "), (_vm.loadSate) ? _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadSate
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.modalFn
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b77193f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/upAvatar/src/upAvatar.vue
// module id = 526
// module chunks = 0